export default __webpack_public_path__ + "img/accha/accha1_1500.webp";